<template>
  <div>
    <v-breadcrumbs :items="crumbs"></v-breadcrumbs>
    <base-loader :isLoading="isLoading"></base-loader>
    <v-row>
      <v-col md="6">
        <v-card>
          <v-card-text>
            <h4 class="text-md-h4 primary--text mb-5">BuildingTag Details</h4>
            <v-simple-table v-if="$route.params.id != 0">
              <tbody>
                <tr>
                  <td>BuildingTag Name</td>
                  <td>
                    {{
                      buildingTagModel.description
                        ? buildingTagModel.description
                        : ""
                    }}
                  </td>
                </tr>
                <tr>
                  <td>BuildingTag Id</td>
                  <td>
                    {{ buildingTagModel.id ? buildingTagModel.id : "" }}
                  </td>
                </tr>
              </tbody>
            </v-simple-table>

            <v-btn
              v-if="$route.params.id == 0"
              color="primary"
              large
              :to="`${$route.path}/edit`"
              class="mr-2"
              >Create a New BuildingTag</v-btn
            >
            <v-btn
              v-else
              large
              color="primary"
              :to="`${$route.path}/edit`"
              class="mr-2"
              >Edit</v-btn
            >
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { BuildingTag } from "@/models/BuildingTag";
import { gql } from "apollo-boost";
export default {
  data() {
    return {
      isEdit: false,
      buildingTagModel: new BuildingTag(),
      me: "",
      search: null,
      crumbs: [
        {
          text: "BuildingTags",
          disabled: false,
          href: "/admin/buildingTags",
        },
        {
          text: "BuildingTag Details",
          disabled: false,
          href: `/admin/buildingTag/${this.$route.params.id}`,
        },
      ],
    };
  },
  created() {},
  apollo: {
    me: gql`
      query {
        me {
          id
        }
      }
    `,
    buildingTag: {
      query: gql`
        query BuildingTag($id: ID!) {
          buildingTag(id: $id) {
            id
            description
            createdBy
            createdAt
            updatedAt
          }
        }
      `,
      fetchPolicy: "network-only",
      skip() {
        return !this.$route.params.id || this.$route.params.id == 0;
      },
      variables() {
        const self = this;
        return {
          id: self.$route.params.id,
          createdBy: self.me.id,
        };
      },
      watchLoading(isLoading) {
        this.isLoading = isLoading;
      },
      result(response, key) {
        this.isLoading = false;
        this.buildingTagModel.id = this.buildingTag.id;
        this.buildingTagModel.description = this.buildingTag.description;
        this.buildingTagModel.createdBy = this.buildingTag.createdBy;
      },
    },
  },
  methods: {},
};
</script>

<style lang="scss" scoped></style>
